import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Widget, WidgetPositioning } from "@src/types/dashboards";

export interface AddWidgetFromTemplateV2Result {
  success: boolean;
  data?: Widget;
  error?: string;
}

/** Send the user's full widget spec to the BE in one POST. The BE
 *  assigns the real id and returns the committed widget. `widget` MUST
 *  have `id` stripped — it's server-assigned. */
export const postAddWidgetFromTemplateV2UseCase = async (
  dashboardId: string,
  widget: Omit<Widget, "id">,
  positioning: WidgetPositioning,
  imageFile?: File | null,
): Promise<AddWidgetFromTemplateV2Result> => {
  try {
    const authContext = store.getState().yourSlice.authContext;
    if (!authContext) {
      return { success: false, error: "Not authenticated" };
    }
    const response = await apiUseCases.postAddWidgetFromTemplateV2(
      authContext.customerNamespace,
      dashboardId,
      widget,
      positioning,
      imageFile,
    );

    return { success: true, data: response.data };
  } catch (error) {
    const parsed = parseAxiosApiError(error, "Failed to add widget");
    return { success: false, error: parsed.message };
  }
};
